module.exports = __webpack_public_path__ + "img/logo.dcccf02b.png";